export default "__VITE_ASSET__rg$y5V8F__"